export default __webpack_public_path__ + "static/media/change-link-img.fc200cdb.svg";